module.exports = __webpack_public_path__ + "static/media/docs.fcf58fc9.png";